import { createContext } from 'react'

const DEFAULT = {
  characters: [...'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ0123456789'].map(value => ({
    value,
    label: value,
  })),
  colors: [
    {
      value: 'Sun',
      colors: ['#FAF7F0', '#FFCD2B'],
      text: {
        standard: '#FAF7F0',
        invert: '#FFCD2B',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Petrol',
      colors: ['#126589', '#F0F8FF'],
      text: {
        standard: '#126589',
        invert: '#F0F8FF',
      },
      logo: {
        standard: '#000',
        invert: '#fff',
      },
    },
    {
      value: 'SoftPink',
      colors: ['#FFADAD', '#FFF3F2'],
      text: {
        standard: '#FFADAD',
        invert: '#FFF3F2',
      },
      logo: {
        standard: '#000',
        invert: '#fff',
      },
    },
    {
      value: 'Peach',
      colors: ['#FF9D49', '#FFF1E5'],
      text: {
        standard: '#FF9D49',
        invert: '#FFF1E5',
      },
      logo: {
        invert: '#fff',
        standard: '#000',
      },
    },
    /*     {
      value: 'Gold',
      colors: ['#FFFFFF', '#AF9869'],
      text: {
        standard: '#FFFFFF',
        invert: '#AF9869',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Greenery',
      colors: ['#FEFFFA', '#ACE96F'],
      text: {
        standard: '#FEFFFA',
        invert: '#ACE96F',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'ClearSky',
      colors: ['#F5FDFF', '#92E5FF'],
      text: {
        standard: '#F5FDFF',
        invert: '#92E5FF',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    }, */
    {
      value: 'Silver',
      colors: ['#DADADA', '#1F1E1C'],
      text: {
        standard: '#DADADA',
        invert: '#1F1E1C',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    /*     {
      value: 'B&W',
      colors: ['#FFFFFF', '#1F1E1C'],
      text: {
        standard: '#FFF',
        invert: '#1F1E1C',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    }, */
    {
      value: 'NightSky',
      colors: ['#DADADA', '#000C68'],
      text: {
        standard: '#DADADA',
        invert: '#000C68',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Techno',
      colors: ['#F0F0F0', '#1B3ACA'],
      text: {
        standard: '#F0F0F0',
        invert: '#1B3ACA',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    /*     {
      value: 'Taxi',
      colors: ['#FFCD2A', '#23221E'],
      text: {
        standard: '#FFCD2A',
        invert: '#23221E',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    }, */
    {
      value: 'Wine',
      colors: ['#4A1032', '#FFE9E4'],
      text: {
        standard: '#4A1032',
        invert: '#FFE9E4',
      },
      logo: {
        standard: '#000',
        invert: '#fff',
      },
    },
    {
      value: 'Eco',
      colors: ['#F4F4F4', '#004B45'],
      text: {
        standard: '#F4F4F4',
        invert: '#004B45',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Japan',
      colors: ['#FFFFFF', '#FC293C'],
      text: {
        standard: '#FFFFFF',
        invert: '#FC293C',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    /*  {
      value: 'NeonGreen',
      colors: ['#FFFFFF', '#D5F802'],
      text: {
        standard: '#FFFFFF',
        invert: '#D5F802',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Mint',
      colors: ['#FFF9F5', '#6DEDBE'],
      text: {
        standard: '#FFF9F5',
        invert: '#6DEDBE',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'NeonPink',
      colors: ['#FFFFFF', '#FF07C6'],
      text: {
        standard: '#FFFFFF',
        invert: '#FF07C6',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Cargo',
      colors: ['#1B3ACA', '#FFC501'],
      text: {
        standard: '#1B3ACA',
        invert: '#FFC501',
      },
      logo: {
        standard: '#fff',
        invert: '#fff',
      },
    },
    {
      value: 'Surf',
      colors: ['#FFF9EE', '#4CB1BB'],
      text: {
        standard: '#FFF9EE',
        invert: '#4CB1BB',
      },
      logo: {
        standard: '#fff',
        invert: '#000',
      },
    },
    {
      value: 'Sunset',
      colors: ['#3E3181', '#FBC37F'],
      text: {
        standard: '#3E3181',
        invert: '#FBC37F',
      },
      logo: {
        standard: '#000',
        invert: '#fff',
      },
    }, */
  ],
  layouts: [
    {
      value: 'standard',
      label: 'Standard',
    },
    {
      value: 'polaroid',
      label: 'Polaroid',
    },
    {
      value: 'framed',
      label: 'Framed',
    },
  ],
}

const DesignContext = createContext({
  styles: {
    Minimal: {
      characters: DEFAULT.characters,
      colors: DEFAULT.colors,
      label: {
        background: '#FEFEFE',
        fill: '#000',
      },
      layouts: DEFAULT.layouts,
    },
    Brush: {
      characters: DEFAULT.characters,
      colors: DEFAULT.colors,
      label: {
        background: '#5A1A71',
        fill: '#F6F4F4',
      },
      layouts: DEFAULT.layouts,
    },
    Glamour: {
      characters: DEFAULT.characters,
      colors: DEFAULT.colors,
      label: {
        background: '#FFE2DA',
        fill: '#000',
      },
      layouts: DEFAULT.layouts,
    },
    Geometric: {
      characters: [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].map(value => ({
        value,
        label: value,
      })),
      colors: DEFAULT.colors,
      label: {
        background: '#FD7345',
        fill: '#FCD846',
      },
      layouts: DEFAULT.layouts,
    },
    Street: {
      characters: DEFAULT.characters,
      colors: DEFAULT.colors,
      label: {
        background: '#FD7345',
        fill: '#FCD846',
      },
      layouts: DEFAULT.layouts,
    },
  },
  constants: {
    offset: {
      '50x70cm': {
        standard: '0',
        polaroid: '1.25',
        framed: '1',
      },
      '70x100cm': {
        standard: '0',
        polaroid: '2',
        framed: '1',
      },
      '30x40cm': {
        standard: '0',
        polaroid: '1',
        framed: '.7',
      },
      '100x150cm': {
        standard: '0',
        polaroid: '3',
        framed: '1',
      },
    },
    layouts: {
      '50x70cm': {
        standard: '50 70',
        polaroid: '47.5 52',
        framed: '50 70',
      },
      '70x100cm': {
        standard: '70 100',
        polaroid: '66 75',
        framed: '70 100',
      },
      '30x40cm': {
        standard: '30 40',
        polaroid: '30 40',
        framed: '30 40',
      },
      '100x150cm': {
        standard: '100 140',
        polaroid: '94 115',
        framed: '100 140',
      },
    },
    text: {
      '50x70cm': {
        standard: '50 10',
        framed: '50 10',
        polaroid: '50 10',
      },
      '70x100cm': {
        standard: '70 10',
        framed: '70 10',
        polaroid: '70 10',
      },
      '30x40cm': {
        standard: '30 10',
        framed: '30 10',
        polaroid: '30 10',
      },
      '100x150cm': {
        standard: '100 10',
        framed: '100 10',
        polaroid: '100 10',
      },
    },
    textOffset: {
      '30x40cm': 50,
      '50x70cm': 60,
      '70x100cm': 75,
      '100x150cm': 100,
    },
    fontSize: {
      '30x40cm': 0.65,
      '50x70cm': 1.05,
      '70x100cm': 1.45,
      '100x150cm': 2.05,
    },
    letterSpacing: {
      '30x40cm': 0.04,
      '50x70cm': 0.09,
      '70x100cm': 0.14,
      '100x150cm': 0.19,
    },
    logo: {
      '50x70cm': {
        size: 2.5,
        offset: {
          standard: '1.3',
          framed: '2.1',
          polaroid: '1.5',
        },
      },
      '70x100cm': {
        size: 3.5,
        offset: {
          standard: '1.8',
          framed: '2.6',
          polaroid: '2',
        },
      },
      '30x40cm': {
        size: 1.5,
        offset: {
          standard: '.8',
          framed: '1',
          polaroid: '1',
        },
      },
      '100x150cm': {
        size: 5.5,
        offset: {
          standard: '2.3',
          framed: '3.1',
          polaroid: '2.5',
        },
      },
    },
    frames: {
      '50x70cm': 1.1,
      '70x100cm': 1.45,
      '30x40cm': 0.75,
      '100x150cm': 0,
      colors: {
        'Uden ramme': 'transparent',
        'Træramme egetræ': '#E4C69F',
        'Træramme hvid': '#FBFBFB',
        'Træramme sort': '#363636',
      },
    },
  },
})

export default DesignContext
